import React, { useState, useEffect } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { Modal, Table, Checkbox, SelectPicker } from 'rsuite';
import moment from 'moment'

import {
    getAllListSupplierNotInCalls,
    getAllMatchedListSupplierNotInCalls,
    getMatchedSuppliersInSendToCalls,
    getAllRemainingListSuppliersIds,
    sendListSuppliersToCalls,
    listSuppliersAddReasonToNotCall,
    changeListSuppliersCallingScript,
    updateListSuppliersInCalls,
    deleteListSuppliersInCalls,
    updateMasterSupplierQAStatus,
    getUnMatchedSupplierInSendToCalls,
    getAllRemainingReenablementSuppliersIds
} from '../../../redux/actions/caller';
import LoaderComponent from '../../CommonComponents/LoaderComponent';
import CheckboxComponent from '../../CommonComponents/CheckboxComponent';
import { toast } from '../../CommonComponents/ToastComponent/toast';
import { getCallerUsers } from '../../../redux/actions/user';
import { getCallingScriptsByPartnerId, getReenablementSuppliers } from '../../../redux/actions/caller';
import FilterComponent from '../listInformationModal/filter-component';
import { checkDateDiff, checkIsAdmin, getAbbreviatedState, getGlobalAcceptanceValue } from '../../../services/helper';
import { getListSuppliers, getMaxLastHistoricalPayment, getSuppliersDataByIds, getSuppliersWithCardAcceptanceData, markListComplete, unassigningSuppliers } from '../../../redux/actions/vendor';

const { Column, HeaderCell, Cell, Pagination } = Table;

export const LinkCell = ({ rowData, dataKey, ...props }) => {
    let status = rowData['approvedByManager'] === 8 ? 'Approved' : rowData['approvedByManager'] === 7 ? 'Rejected' : 'Pending';
    let bgColorClass = status.toLowerCase() === 'approved' ? 'bg-green' : status.toLowerCase() === 'rejected' ? 'bg-red' : 'bg-yellow';
    return (
        <Cell {...props} className="table-link">
            <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
                {status}
            </h5>
        </Cell>
    );
};

const SendToCallsModal = ({
    show,
    handleClose,
    columns,
    listId,
    partnerId,
    selectedCompany,
    suppliersMatched,
    selectedCompanyStatus,
    isFromMarkListComplete = false,
    selectedCompanyDetails,
    isReenablementToCalls = false
}) => {
    const filterColumns = [
        { label: 'Supplier Name', name: 'suppliername', options: [] },
        { label: 'Caller Assigned', name: 'callerAssigned', options: [] },
        { label: 'Spend', name: 'spend', options: [] },
        { label: 'Show All Assigned', name: 'showAllAssigned', options: [] }
    ];

    const tabs = [
        { label: 'Unmatched Suppliers', value: 'unmatched' },
        { label: 'Matched Suppliers', value: 'matched' },
    ];
    const dispatch = useDispatch();
    const store = useStore().getState();
    const {
        app: { supplierAllColumns },
        domain: { currentDomain },
    } = store;

    const reasonToNotCallOptions = ['Personal Name', 'Intracompany', 'International Vendor', 'Under Spend Threshold', 'Insufficient Information', 'Duplicate Vendor', 'Customer Requested to not call', 'Enablement Not Needed'];
    const [currentTab, setCurrentTab] = useState('unmatched');
    const [callerOptions, setCallerOptions] = useState([]);
    const [checked, setChecked] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [matchedLimit, setMatchedLimit] = useState(10);
    const [matchedPage, setMatchedPage] = useState(1);
    const [tableData, setTableData] = useState([]);
    const [totalTableRecords, setTableTotalRecords] = useState(0);
    const [matchedTableData, setMatchedTableData] = useState([]);
    const [totalMatchedTableRecords, setTotalMatchedTableRecords] = useState(0);
    const [sortColumn, setSortColumn] = useState('suppliername');
    const [sortType, setSortType] = useState('asc');
    const [reasonToNotCall, setReasonToNotCall] = useState('');
    const [callerAssigned, setCallerAssigned] = useState('');
    const [callingScriptId, setCallingScriptId] = useState(null);
    const [reasonToNotCallPerVendor, setReasonToNotCallPerVendor] = useState([]);
    const [callerAssignedPerVendor, setCallerAssignedPerVendor] = useState([]);
    const [callingScriptPerVendor, setCallingScriptPerVendor] = useState([]);
    const [isLoadingTableData, setIsLoadingTableData] = useState(false);
    const [selectAllRemaining, setSelectAllRemaining] = useState(false);
    const [remainingCheckedKeys, setRemainingCheckedKeys] = useState([]);
    const [isChangesApplied, setIsChangesApplied] = useState(null);
    const [isSendToCallLoading, setIsSendToCallLoading] = useState(false);
    const [callingScripts, setCallingScripts] = useState([]);
    const [isShowAllSuppliers, setIsShowAllSuppliers] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const [inCallsFilters, setInCallsFilters] = useState({});
    const [paginatedMatchedResult, setPaginatedMatchedResult] = useState([]);
    const [matchedSupplierList, setMatchedSupplierList] = useState([]);
    const [isMarkingListComplete, setIsMarkingListComplete] = useState(false);
    const [paginatedData, setPaginatedData] = useState([])
    const [isSpendGreater, setIsSpendGreater] = useState(true);

    const isAdmin = checkIsAdmin(currentDomain);

    useEffect(() => {
        getTableData(limit, 0, sortColumn, sortType, true, isShowAllSuppliers, inCallsFilters);
    }, [limit, page]);

    useEffect(() => {
        setReasonToNotCallPerVendor([]);
        setCallerAssignedPerVendor([]);
        setCallingScriptPerVendor([]);
        setSelectAllRemaining(false);
        setRemainingCheckedKeys([]);
        setIsShowAllSuppliers(false);
        setInCallsFilters({});
        setIsChangesApplied(null);
        setIsFilterApplied(false);
        if (currentTab === 'matched') {
            getMatchedTableData();
        } else {
            setMatchedTableData([]);
        }
    }, [currentTab]);

    const getTableData = async (limit, offset, sortColumn, sortType, isGetCallers = false, isShowAllSuppliers = false, filterData = {}) => {
        offset = (page - 1) * limit;
        setIsLoadingTableData(true);
        if (filterData && filterData?.hasOwnProperty("spend")) {
            filterData.isSpendGreater = isSpendGreater
        }
        if (isReenablementToCalls) {
            dispatch(getReenablementSuppliers({ limit, offset, sortColumn, sortType, isShowAllSuppliers, filterData }))
                .then(async (result) => {
                    setTableData(result?.reenablementSuppliers);
                    setTableTotalRecords(result?.total);
                    setIsLoadingTableData(false);

                    if (isGetCallers) {
                        setIsLoadingTableData(true);
                        dispatch(getCallerUsers()).then(result => {
                            let tmpCallers = result.length ? result.map(user => {
                                return {
                                    label: user?.firstname + (user?.lastname ? ' ' + user?.lastname : ''),
                                    value: user?.id
                                };
                            }) : [];
                            setCallerOptions(tmpCallers);
                            setIsLoadingTableData(false);
                        }).catch(() => {
                            setCallerOptions([]);
                            setIsLoadingTableData(false);
                        });

                        dispatch(getCallingScriptsByPartnerId(result?.partnerId?.id)).then(scripts => {
                            setCallingScripts(scripts);
                        }).catch(() => {
                            setCallingScripts([]);
                        });
                    }
                    await setInitialData(isShowAllSuppliers, filterData, result);
                })
                .catch(() => {
                    setIsLoadingTableData(false);
                    setTableData([]);
                    setTableTotalRecords(0);
                    toast.show({
                        title: 'Danger',
                        description: `Unable to fetch the suppliers for reenablement`,
                    });
                });
        } else {
            if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                await dispatch(getUnMatchedSupplierInSendToCalls({ listId, limit: limit, offset: offset, sortColumn, sortType, isShowAllSuppliers, filterData, selectedCompanyStatus }))
                    .then(async (results) => {
                        const result = getFilteredDataForUnMatchedSuppliers(results?.listSuppliers);

                        setTableData(result);
                        setTableTotalRecords(results?.totalRecords || 0);

                        const paginatedUnMatchedData = result?.sort((a, b) => {
                        }).slice(limit * (1 - 1), limit * 1);

                        const matchedSupplierIds = paginatedUnMatchedData?.map((sup) => sup?.matchedSupplierId);
                        await getSuppliersByIds(matchedSupplierIds);

                        setPaginatedData(paginatedUnMatchedData);
                        const isAllChecked = result?.filter(item => checkedKeys.includes(item.id));
                        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === result?.length) ? false : true);
                        setChecked(isAllChecked?.length === result?.length ? true : false);

                        if (isGetCallers) {
                            dispatch(getCallerUsers()).then(result => {
                                let tmpCallers = result.length ? result.map(user => {
                                    return {
                                        label: user?.firstname + (user?.lastname ? ' ' + user?.lastname : ''),
                                        value: user?.id
                                    };
                                }) : [];
                                setCallerOptions(tmpCallers);
                            }).catch(() => {
                                setCallerOptions([]);
                                setIsLoadingTableData(false);
                            });
                        }
                        await setInitialDataFinal(isShowAllSuppliers, filterData, result);
                        setIsLoadingTableData(false);
                    }).catch((err) => {
                        setTableData([]);
                        setTableTotalRecords(0);
                        setIsLoadingTableData(false);
                    });
            } else {
                await dispatch(getAllListSupplierNotInCalls({ listId, limit: limit, offset: offset, sortColumn, sortType, isShowAllSuppliers, filterData })).then(async (result) => {
                    setTableData(result?.listSuppliers);
                    setMatchedSupplierList([]);
                    setTableTotalRecords(result?.totalRecords);
                    const isAllChecked = result?.listSuppliers.filter(item => checkedKeys.includes(item.id));
                    setIndeterminate((!isAllChecked?.length || isAllChecked?.length === result?.listSuppliers?.length) ? false : true);
                    setChecked(isAllChecked?.length === result?.listSuppliers?.length ? true : false);

                    if (isGetCallers) {
                        dispatch(getCallerUsers()).then(result => {
                            let tmpCallers = result.length ? result.map(user => {
                                return {
                                    label: user?.firstname + (user?.lastname ? ' ' + user?.lastname : ''),
                                    value: user?.id
                                };
                            }) : [];
                            setCallerOptions(tmpCallers);
                        }).catch((err) => {
                            setCallerOptions([]);
                            setIsLoadingTableData(false);
                        });
                    }

                    await setInitialData(isShowAllSuppliers, filterData, result);
                    setIsLoadingTableData(false);
                }).catch((err) => {
                    setTableData([]);
                    setTableTotalRecords(0);
                    setIsLoadingTableData(false);
                });
            }
        }
    };

    const setInitialData = async (isShowAllSuppliers, filterData, result) => {
        if (isReenablementToCalls) {
            if (isShowAllSuppliers || (Object.keys(filterData)?.length > 0 && (filterData?.suppliername || filterData?.callerAssigned))) {
                if (result?.reenablementSuppliers?.length) {
                    let tmpCallerAssignedPerVendor = [];
                    let tmpReasonToNotCallPerVendor = [];
                    let tmpCallingScriptPerVendorr = [];

                    for (var i = 0; i < result?.reenablementSuppliers?.length; i++) {
                        if (result?.reenablementSuppliers?.[i]?.vendorsInCall) {
                            let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === result?.reenablementSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                if (result?.reenablementSuppliers?.[i]?.vendorsInCall?.callerAssigned) {
                                    tmpCallerAssignedPerVendor.push({
                                        listSupplierId: result?.reenablementSuppliers?.[i]?.id,
                                        callerAssigned: result?.reenablementSuppliers?.[i]?.vendorsInCall?.callerAssigned,
                                        isUpdate: false,
                                        isDelete: false,
                                        masterId: result?.reenablementSuppliers?.[i]?.matchedSupplierId
                                    });
                                }
                            }
                        }
                        if (result?.reenablementSuppliers?.[i]?.reasonToNotCall) {
                            let vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === result?.reenablementSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                tmpReasonToNotCallPerVendor.push({
                                    listSupplierId: result?.reenablementSuppliers?.[i]?.id,
                                    reasonToNotCall: result?.reenablementSuppliers?.[i]?.reasonToNotCall,
                                    isUpdate: false,
                                    isDelete: false
                                });
                            }
                        }
                        if (result?.reenablementSuppliers?.[i]?.callingScriptId) {
                            let vendorIndex = tmpCallingScriptPerVendorr.findIndex(vendor => vendor.listSupplierId === result?.reenablementSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                tmpCallingScriptPerVendorr.push({
                                    listSupplierId: result?.reenablementSuppliers?.[i]?.id,
                                    callingScriptId: result?.reenablementSuppliers?.[i]?.callingScriptId
                                });
                            }
                        }
                    }
                    setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
                    setCallingScriptPerVendor(tmpCallingScriptPerVendorr);
                    setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
                }
            } else {
                setCallerAssignedPerVendor([]);
                setCallingScriptPerVendor([]);
                setReasonToNotCallPerVendor([]);
            }
        } else {
            if (isShowAllSuppliers || (Object.keys(filterData)?.length > 0 && (filterData?.suppliername || filterData?.callerAssigned))) {
                if (result?.listSuppliers?.length) {
                    let tmpCallerAssignedPerVendor = [];
                    let tmpReasonToNotCallPerVendor = [];
                    let tmpCallingScriptPerVendorr = [];

                    for (var i = 0; i < result?.listSuppliers?.length; i++) {
                        if (result?.listSuppliers?.[i]?.vendorsInCall) {
                            let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === result?.listSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                if (result?.listSuppliers?.[i]?.vendorsInCall?.callerAssigned) {
                                    tmpCallerAssignedPerVendor.push({
                                        listSupplierId: result?.listSuppliers?.[i]?.id,
                                        callerAssigned: result?.listSuppliers?.[i]?.vendorsInCall?.callerAssigned,
                                        isUpdate: false,
                                        isDelete: false,
                                        masterId: result?.listSuppliers?.[i]?.matchedSupplierId
                                    });
                                }
                            }
                        }
                        if (result?.listSuppliers?.[i]?.reasonToNotCall) {
                            let vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === result?.listSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                tmpReasonToNotCallPerVendor.push({
                                    listSupplierId: result?.listSuppliers?.[i]?.id,
                                    reasonToNotCall: result?.listSuppliers?.[i]?.reasonToNotCall,
                                    isUpdate: false,
                                    isDelete: false
                                });
                            }
                        }
                        if (result?.listSuppliers?.[i]?.callingScriptId) {
                            let vendorIndex = tmpCallingScriptPerVendorr.findIndex(vendor => vendor.listSupplierId === result?.listSuppliers?.[i]?.id);
                            if (vendorIndex === -1) {
                                tmpCallingScriptPerVendorr.push({
                                    listSupplierId: result?.listSuppliers?.[i]?.id,
                                    callingScriptId: result?.listSuppliers?.[i]?.callingScriptId
                                });
                            }
                        }
                    }
                    setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
                    setCallingScriptPerVendor(tmpCallingScriptPerVendorr);
                    setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
                }
            } else {
                setCallerAssignedPerVendor([]);
                setCallingScriptPerVendor([]);
                setReasonToNotCallPerVendor([]);
            }
        }
    };

    const setInitialDataFinal = async (isShowAllSuppliers, filterData, result) => {
        if (isShowAllSuppliers || (Object.keys(filterData)?.length > 0 && (filterData?.suppliername || filterData?.callerAssigned))) {
            if (result?.length) {
                let tmpCallerAssignedPerVendor = [];
                let tmpReasonToNotCallPerVendor = [];
                let tmpCallingScriptPerVendorr = [];

                for (let i = 0; i < result?.length; i++) {
                    if (result?.[i]?.vendorsInCall) {
                        let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            if (result?.[i]?.vendorsInCall?.callerAssigned) {
                                tmpCallerAssignedPerVendor.push({
                                    listSupplierId: result?.[i]?.id,
                                    callerAssigned: result?.[i]?.vendorsInCall?.callerAssigned,
                                    isUpdate: false,
                                    isDelete: false,
                                    masterId: result?.[i]?.matchedSupplierId
                                });
                            }
                        }
                    }
                    if (result?.[i]?.reasonToNotCall) {
                        let vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            tmpReasonToNotCallPerVendor.push({
                                listSupplierId: result?.[i]?.id,
                                reasonToNotCall: result?.[i]?.reasonToNotCall,
                                isUpdate: false,
                                isDelete: false
                            });
                        }
                    }
                    if (result?.[i]?.callingScriptId) {
                        let vendorIndex = tmpCallingScriptPerVendorr.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            tmpCallingScriptPerVendorr.push({
                                listSupplierId: result?.[i]?.id,
                                callingScriptId: result?.[i]?.callingScriptId
                            });
                        }
                    }
                }

                setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
                setCallingScriptPerVendor(tmpCallingScriptPerVendorr);
                setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
            }
        } else {
            setCallerAssignedPerVendor([]);
            setCallingScriptPerVendor([]);
            setReasonToNotCallPerVendor([]);
        }
    };

    const getFilteredDataForUnMatchedSuppliers = (tableData) => {
        let filteredData;
        var dateDiff = false;

        filteredData = tableData?.filter((row) => {
            if (row?.cardAcceptance) {
                const { isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa } = row?.cardAcceptance;
                if (isAcceptAmericanExpress !== null || isAcceptMasterCard !== null || isAcceptVisa !== null) {
                    if (row?.supplierDetail?.contactDate) {
                        dateDiff = checkDateDiff(new Date(row?.supplierDetail?.contactDate), 18);
                    } else {
                        dateDiff = true;
                    }
                } else if (isAcceptAmericanExpress === null && isAcceptMasterCard === null && isAcceptVisa === null) {
                    dateDiff = true;
                }
            } else {
                dateDiff = true;
            }

            if (dateDiff) {
                return row;
            }
        });

        return filteredData;
    };

    const getMatchedTableData = async (isShowAllSuppliers = false, filterData = {}, sortType = "asc", sortColumn = "suppliername") => {
        if (parseInt(suppliersMatched)) {
            let limit = 100;
            let listSuppliers = [];
            let filteredListSuppliers = [];
            if (filterData && filterData?.hasOwnProperty("spend")) {
                filterData.isSpendGreater = isSpendGreater
            }

            for (let offset = 0; offset < parseInt(suppliersMatched); offset += limit) {
                setIsLoadingTableData(true);

                if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                    const results = await dispatch(getMatchedSuppliersInSendToCalls({ listId, isShowAllSuppliers, filterData, limit, offset }))
                        .then(res => res)
                        .catch(err => []);
                    listSuppliers = [...listSuppliers, ...results?.listSuppliers];
                    let tmpFilteredListSuppliers = await getFilteredMatchSuppliers(results?.listSuppliers, isShowAllSuppliers);
                    filteredListSuppliers = [...filteredListSuppliers, ...tmpFilteredListSuppliers]
                } else {
                    const results = await dispatch(getAllMatchedListSupplierNotInCalls({ listId, isShowAllSuppliers, filterData, limit, offset }))
                        .then(res => res)
                        .catch(err => []);
                    listSuppliers = [...listSuppliers, ...results?.listSuppliers];
                    filteredListSuppliers = await getFilteredDataForMatchedSuppliers(listSuppliers, isShowAllSuppliers, filterData);
                }
            }

            setMatchedTableData(filteredListSuppliers);
            setTotalMatchedTableRecords(filteredListSuppliers?.length || 0);
            let sortedData = onSortColumn(filteredListSuppliers, sortType, sortColumn);
            let paginatedMatchedData = sortedData.slice(matchedLimit * (1 - 1), matchedLimit * 1);
            if (paginatedMatchedData?.length > 0) {
                let matchedSuppliersData = []
                let suppliersCardData = []
                let masterIds = []
                let historicPaymentsMaxDates = []
                if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                    masterIds = paginatedMatchedData?.map((row) => row?.masterCardAcceptance?.supplierId)
                } else {
                    masterIds = paginatedMatchedData?.map((row) => row?.matchedMasterId)

                    const matchedSupplierIdList = paginatedMatchedData?.map(item => item?.matchedSupplierId);
                    matchedSuppliersData = await getSuppliersByIds(matchedSupplierIdList)

                    const matchedSuppliersIds = paginatedMatchedData?.map(({ matchedSupplierId }) => {
                        let supplier = matchedSuppliersData?.find((sup) => sup?.id === matchedSupplierId);
                        matchedSupplierId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
                        return matchedSupplierId;
                    });

                    const uniqueMatchedSuppliersIds = [...new Set(matchedSuppliersIds)];
                    if (uniqueMatchedSuppliersIds && uniqueMatchedSuppliersIds?.length > 0) {
                        suppliersCardData = await dispatch(getSuppliersWithCardAcceptanceData(uniqueMatchedSuppliersIds)).then(res => res).catch(() => []);
                    }
                }

                if (masterIds && masterIds?.length > 0) {
                    historicPaymentsMaxDates = await dispatch(getMaxLastHistoricalPayment({ masterIds }))
                        .then(res => res)
                        .catch(() => []);
                }
                paginatedMatchedData = await Promise.all(paginatedMatchedData?.map(async (row) => {
                    // get global acceptance
                    let cardData = null
                    let masterId = null
                    if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                        cardData = row?.masterCardAcceptance
                        masterId = row?.masterCardAcceptance?.supplierId
                    } else {
                        cardData = { isAcceptGlobalAcceptance: row?.isAcceptMatchedGlobalAcceptance }
                        masterId = row?.matchedMasterId

                        let supplier = matchedSuppliersData?.find((sup) => sup?.id === row?.matchedSupplierId);

                        const matchedMasterId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
                        const listMasterSupCardAcc = suppliersCardData?.filter((cardData) => cardData?.cardAcceptance?.[0]?.supplierId === matchedMasterId)?.[0] || null;

                        if (listMasterSupCardAcc) {
                            // get card remittance
                            var acceptsEmail, acceptsPhone, acceptsWeb, acceptsFax, acceptsEcom, acceptsInApp, acceptsPos
                            acceptsEmail = acceptsPhone = acceptsWeb = acceptsFax = acceptsEcom = acceptsInApp = acceptsPos = false
                            if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByEmail && listMasterSupCardAcc?.cardAcceptanceEmails?.length > 0) {
                                acceptsEmail = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByPhone && (
                                (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPOTSPhone && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentByPhoneValue) ||
                                (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptIVRPhone && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentIVRPhone)
                            )) {
                                acceptsPhone = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && (
                                (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.portalUrl) ||
                                (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAccept3rdPartyPortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.thirdPartyPortalUrl)
                            )) {
                                acceptsWeb = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByFax && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentByFaxValue) {
                                acceptsFax = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptEcommercePortal) {
                                acceptsEcom = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptInAppPortal) {
                                acceptsInApp = true
                            } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPointOfSalePortal) {
                                acceptsPos = true
                            }

                            if (acceptsEmail || acceptsPhone || acceptsWeb || acceptsFax || acceptsEcom || acceptsInApp || acceptsPos) {
                                row.cardRemittance = "Yes"
                            } else {
                                row.cardRemittance = "No"
                            }
                        } else {
                            row.cardRemittance = "No"
                        }
                    }
                    const acceptanceType = await getGlobalAcceptanceValue(cardData, masterId, dispatch)
                    row.globalAcceptance = acceptanceType || 'Unknown'
                    // Maximum last payment date
                    const maxLastPaymentDate = historicPaymentsMaxDates?.find(payment => parseInt(payment.masterId) === parseInt(masterId))?.maxLastPayment
                    row.lastPaymentDate = maxLastPaymentDate ? moment(maxLastPaymentDate).format('MM/DD/YYYY') : ''
                    return row
                }))
            }
            setPaginatedMatchedResult(paginatedMatchedData);
            setMatchedPage(1);
            const isAllChecked = filteredListSuppliers?.filter(item => checkedKeys.includes(item.id));
            setIndeterminate((!isAllChecked?.length || isAllChecked?.length === filteredListSuppliers?.length) ? false : true);
            setChecked(isAllChecked?.length === filteredListSuppliers?.length ? true : false);
            await setDropDownActionsValue(isShowAllSuppliers, filterData, filteredListSuppliers);
            setIsLoadingTableData(false);
        } else {
            setMatchedTableData([]);
            setTotalMatchedTableRecords(0);
        }
    };

    const getFilteredMatchSuppliers = async (tableData, isShowAllSuppliers, filterData) => {
        const cuttOffDate = new Date();
        cuttOffDate.setMonth(cuttOffDate.getMonth() - 18);
        const cuttOffDt = new Date(cuttOffDate).getTime();
        const matchedSupplierIds = tableData?.map(data => data.matchedSupplierId);
        const matchedSuppliersData = await dispatch(getSuppliersDataByIds(matchedSupplierIds)).then((res) => res).catch(err => []);

        const matchedSuppliersIds = tableData?.map(({ matchedSupplierId }) => {
            let supplier = matchedSuppliersData?.find((sup) => sup?.id === matchedSupplierId);
            matchedSupplierId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
            return matchedSupplierId;
        });

        const uniqueMatchedSuppliersIds = [...new Set(matchedSuppliersIds)];
        const suppliersCardData = await dispatch(getSuppliersWithCardAcceptanceData(uniqueMatchedSuppliersIds)).then(res => res).catch(err => []);

        let finalData = tableData.map((listSup) => {
            let recordSelected = false;
            let supplier = matchedSuppliersData?.find((sup) => sup?.id === listSup?.matchedSupplierId);

            const masterId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
            const listSupCardAcc = suppliersCardData.filter((cardData) => cardData?.cardAcceptance?.[0]?.supplierId === masterId);

            if (listSupCardAcc?.[0]?.cardAcceptance?.[0]) {
                const { isAcceptAmericanExpress, isAcceptMasterCard, isAcceptVisa } = listSupCardAcc?.[0]?.cardAcceptance?.[0];
                if (isAcceptAmericanExpress !== null || isAcceptMasterCard !== null || isAcceptVisa !== null) {
                    if (isShowAllSuppliers) {
                        if (listSup?.vendorsInCall?.lastCalledDate && new Date(listSup?.vendorsInCall?.lastCalledDate).getTime() > cuttOffDt && listSup?.vendorsInCall?.status?.toLowerCase() === 'approved') {
                            recordSelected = false;
                        } else {
                            recordSelected = true;
                        }
                    } else {
                        if (listSup?.vendorsInCall === null) {
                            recordSelected = true;
                        } else {
                            if (listSup?.vendorsInCall?.lastCalledDate) {
                                const lastCalledDt = new Date(listSup?.vendorsInCall?.lastCalledDate).getTime();
                                recordSelected = lastCalledDt < cuttOffDt ? true : false;
                            } else {
                                recordSelected = true;
                            }
                        }
                    }
                } else if (isAcceptAmericanExpress === null && isAcceptMasterCard === null && isAcceptVisa === null) {
                    recordSelected = true;
                }
            } else {
                recordSelected = true;
            }

            if (recordSelected) {
                return {
                    ...listSup,
                    masterCardAcceptance: listSupCardAcc?.[0]?.cardAcceptance?.[0] || null,
                    masterCardEmails: listSupCardAcc?.[0]?.cardAcceptanceEmails?.length ? listSupCardAcc?.[0]?.cardAcceptanceEmails : []
                };
            }
        });
        if (finalData && finalData?.length) {
            let tmpFinalData = finalData.filter(Boolean);
            finalData = await Promise.all(tmpFinalData?.map(async (row) => {
                let cardAcceptance = "Unknown"
                if (row?.masterCardAcceptance?.isAcceptAmericanExpress || row?.masterCardAcceptance?.isAcceptMasterCard || row?.masterCardAcceptance?.isAcceptVisa) {
                    cardAcceptance = 'Yes'
                } else if (row?.masterCardAcceptance?.isAcceptAmericanExpress === false || row?.masterCardAcceptance?.isAcceptMasterCard === false || row?.masterCardAcceptance?.isAcceptVisa === false) {
                    cardAcceptance = 'No'
                }
                row.cardAcceptance = cardAcceptance

                // get card remittance
                var acceptsEmail, acceptsPhone, acceptsWeb, acceptsFax, acceptsEcom, acceptsInApp, acceptsPos
                acceptsEmail = acceptsPhone = acceptsWeb = acceptsFax = acceptsEcom = acceptsInApp = acceptsPos = false
                if (row?.masterCardAcceptance?.isAcceptCardPaymentByEmail && row?.masterCardEmails?.length > 0) {
                    acceptsEmail = true
                } else if (row?.masterCardAcceptance?.isAcceptCardPaymentByPhone && (
                    (row?.masterCardAcceptance?.isAcceptPOTSPhone && row?.masterCardAcceptance?.cardPaymentByPhoneValue) ||
                    (row?.masterCardAcceptance?.isAcceptIVRPhone && row?.masterCardAcceptance?.cardPaymentIVRPhone)
                )) {
                    acceptsPhone = true
                } else if (row?.masterCardAcceptance?.isAcceptCardPaymentByOnlinePortal && (
                    (row?.masterCardAcceptance?.isAcceptPortal && row?.masterCardAcceptance?.portalUrl) ||
                    (row?.masterCardAcceptance?.isAccept3rdPartyPortal && row?.masterCardAcceptance?.thirdPartyPortalUrl)
                )) {
                    acceptsWeb = true
                } else if (row?.masterCardAcceptance?.isAcceptCardPaymentByFax && row?.masterCardAcceptance?.cardPaymentByFaxValue) {
                    acceptsFax = true
                } else if (row?.masterCardAcceptance?.isAcceptCardPaymentByOnlinePortal && row?.masterCardAcceptance?.isAcceptEcommercePortal) {
                    acceptsEcom = true
                } else if (row?.masterCardAcceptance?.isAcceptCardPaymentByOnlinePortal && row?.masterCardAcceptance?.isAcceptInAppPortal) {
                    acceptsInApp = true
                } else if (row?.masterCardAcceptance?.isAcceptPointOfSalePortal) {
                    acceptsPos = true
                }

                if (acceptsEmail || acceptsPhone || acceptsWeb || acceptsFax || acceptsEcom || acceptsInApp || acceptsPos) {
                    row.cardRemittance = "Yes"
                } else {
                    row.cardRemittance = "No"
                }
                return row
            }))
        }
        return finalData;
    };

    const getFilteredDataForMatchedSuppliers = async (tableData) => {
        let filteredData = [];
        if (tableData && tableData?.length) {
            filteredData = tableData.map((row, ind) => {
                if (row?.callstatus?.toLowerCase() === 'approved') {
                    return;
                }
                if (row.isAcceptAmericanExpress === null && row.isAcceptMasterCard === null && row.isAcceptVisa === null && row.isAcceptMatchedAmericanExpress === null && row.isAcceptMatchedMasterCard === null && row.isAcceptMatchedVisa === null) {
                    return row;
                } else {
                    let dateDiff = false;
                    let matchedDateDiff = false;

                    if (row.isAcceptAmericanExpress !== null || row.isAcceptMasterCard !== null || row.isAcceptVisa !== null) {
                        if (!row?.contactDate) {
                            dateDiff = true;
                        } else {
                            dateDiff = checkDateDiff(new Date(row?.contactDate), 18);
                        }
                    }
                    if (row.isAcceptMatchedAmericanExpress !== null || row.isAcceptMatchedMasterCard !== null || row.isAcceptMatchedVisa !== null) {
                        if (!row?.matchedContactDate) {
                            matchedDateDiff = true;
                        } else {
                            matchedDateDiff = checkDateDiff(new Date(row?.matchedContactDate), 18);
                        }
                    }
                    if (dateDiff || matchedDateDiff) {
                        return row;
                    }
                }
            });

        }
        if (filteredData && filteredData?.length) {
            let tmpFilteredData = filteredData.filter(Boolean);
            filteredData = await Promise.all(tmpFilteredData?.map(async (row) => {
                let cardAcceptance = "Unknown"
                if (row.isAcceptMatchedAmericanExpress || row.isAcceptMatchedMasterCard || row.isAcceptMatchedVisa) {
                    cardAcceptance = 'Yes'
                } else if (row.isAcceptMatchedAmericanExpress === false || row.isAcceptMatchedMasterCard === false || row.isAcceptMatchedVisa === false) {
                    cardAcceptance = 'No'
                }
                row.cardAcceptance = cardAcceptance
                return row
            }))
        }
        return filteredData;
    };

    const setDropDownActionsValue = async (isShowAllSuppliers, filterData, result) => {
        if (isShowAllSuppliers || (Object.keys(filterData)?.length > 0 && (filterData?.suppliername || filterData?.callerAssigned))) {
            if (result?.length) {
                let tmpCallerAssignedPerVendor = [];
                let tmpReasonToNotCallPerVendor = [];
                let tmpCallingScriptPerVendorr = [];

                for (let i = 0; i < result?.length; i++) {
                    if (result?.[i]?.vendorsInCall) {
                        let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            if (result?.[i]?.vendorsInCall?.callerAssigned) {
                                tmpCallerAssignedPerVendor.push({
                                    listSupplierId: result?.[i]?.id,
                                    callerAssigned: result?.[i]?.vendorsInCall?.callerAssigned,
                                    isUpdate: false,
                                    isDelete: false,
                                    masterId: result?.[i]?.matchedSupplierId
                                });
                            }
                        }
                    }
                    if (result?.[i]?.reasonToNotCall) {
                        let vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            tmpReasonToNotCallPerVendor.push({
                                listSupplierId: result?.[i]?.id,
                                reasonToNotCall: result?.[i]?.reasonToNotCall,
                                isUpdate: false,
                                isDelete: false
                            });
                        }
                    }
                    if (result?.[i]?.callingScriptId) {
                        let vendorIndex = tmpCallingScriptPerVendorr.findIndex(vendor => vendor.listSupplierId === result?.[i]?.id);
                        if (vendorIndex === -1) {
                            tmpCallingScriptPerVendorr.push({
                                listSupplierId: result?.[i]?.id,
                                callingScriptId: result?.[i]?.callingScriptId
                            });
                        }
                    }
                }

                setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
                setCallingScriptPerVendor(tmpCallingScriptPerVendorr);
                setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
            }
        } else {
            setCallerAssignedPerVendor([]);
            setCallingScriptPerVendor([]);
            setReasonToNotCallPerVendor([]);
        }
    };

    const onSortColumn = (suppliers, sortType, sortColumn) => {
        let data = [];
        if (sortColumn === 'suppliername') {
            if (sortType === 'asc') {
                data = suppliers?.sort((a, b) => {
                    const valA = a?.suppliername?.toLowerCase() || "";
                    const valB = b?.suppliername?.toLowerCase() || "";
                    if (valA !== valB) {
                        return valA.localeCompare(valB);
                    }
                });
            } else {
                data = suppliers?.sort((a, b) => {
                    const valA = a?.suppliername?.toLowerCase() || "";
                    const valB = b?.suppliername?.toLowerCase() || "";
                    if (valB !== valA) {
                        return valB.localeCompare(valA);
                    }
                });
            }
        } else if (sortColumn === 'spend') {
            if (sortType === 'asc') {
                data = suppliers?.sort((a, b) => {
                    const valA = a?.spend || 0;
                    const valB = b?.spend || 0;
                    if (valA !== valB) {
                        return valA - valB;
                    }
                });
            } else {
                data = suppliers?.sort((a, b) => {
                    const valA = a?.spend || 0;
                    const valB = b?.spend || 0;
                    if (valB !== valA) {
                        return valB - valA;
                    }
                });
            }
        }
        return data;
    };

    const handleCheckAll = (value, checked) => {
        let keys = [...checkedKeys];
        if (isReenablementToCalls) {
            if (checked) {
                keys = tableData.map(item => item.id);
            } else {
                tableData.map(item => {
                    let index = keys.findIndex(key => key === item.id);
                    if (index !== -1) {
                        keys.splice(index, 1);
                    }
                });
            }
        } else {
            if ((selectedCompanyStatus.toLowerCase() === 'matching complete') && currentTab === 'unmatched') {
                if (checked) {
                    keys = tableData.map(item => item.id);
                } else {
                    tableData.map(item => {
                        let index = keys.findIndex(key => key === item.id);
                        if (index !== -1) {
                            keys.splice(index, 1);
                        }
                    });
                }
            } else {
                if (checked) {
                    if (currentTab === 'unmatched') {
                        keys = paginatedData.map(item => item.id);
                    } else {
                        keys = paginatedMatchedResult.map(item => item.id);
                    }
                } else {
                    const data = currentTab === 'unmatched' ? [...paginatedData] : [...paginatedMatchedResult];
                    data.map(item => {
                        let index = keys.findIndex(key => key === item.id);
                        if (index !== -1) {
                            keys.splice(index, 1);
                        }
                    });
                }
            }
        }
        setCheckedKeys(keys);
        setIndeterminate(false);
        setChecked(checked);
        setIsChangesApplied(false);
    };

    const handleCheck = (value, checked) => {
        var nextCheckedKeys;
        let tmpCallerAssignedPerVendor = [...callerAssignedPerVendor];
        let tmpReasonToNotCallPerVendor = [...reasonToNotCallPerVendor];
        let tmpCallingScriptPerVendor = [...callingScriptPerVendor];
        if (checked) {
            nextCheckedKeys = [...checkedKeys, value];
        } else {
            nextCheckedKeys = checkedKeys.filter(item => { if (item !== value) { return item; } });
            let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.vendorId === value);
            let vendorIndex1 = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.vendorId === value);
            let vendorIndex2 = tmpCallingScriptPerVendor.findIndex(vendor => vendor.vendorId === value);
            if (vendorIndex !== -1) {
                tmpCallerAssignedPerVendor.splice(vendorIndex, 1);
            }
            if (vendorIndex1 !== -1) {
                tmpReasonToNotCallPerVendor.splice(vendorIndex1, 1);
            }
            if (vendorIndex2 !== -1) {
                tmpCallingScriptPerVendor.splice(vendorIndex2, 1);
            }
        }
        setCheckedKeys(nextCheckedKeys);
        setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
        setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
        setCallingScriptPerVendor(tmpCallingScriptPerVendor);
        const isAllChecked = tableData.filter(item => nextCheckedKeys.includes(item.id));
        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true);
        setChecked(isAllChecked?.length === tableData?.length ? true : false);
    };

    const handleChangeLimit = async (dataKey) => {
        setPage(1);
        setLimit(dataKey);
        if (isReenablementToCalls) {
            await getTableData(dataKey, 0, sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
        } else {
            if (selectedCompanyStatus.toLowerCase() === 'matching complete') {
                await getTableData(dataKey, 0, sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
            }
            if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                const paginatedUnMatchedData = tableData?.sort((a, b) => {
                }).slice(dataKey * (1 - 1), dataKey * 1);
                const matchedSupplierId = paginatedUnMatchedData.map(sup => sup?.matchedSupplierId);
                await getSuppliersByIds(matchedSupplierId);
                setPaginatedData(paginatedUnMatchedData);
            }
        }
        setCheckedKeys([]);
        setIndeterminate(false);
        setChecked(false);
    };

    const handleChangePage = async (event) => {
        if (isReenablementToCalls) {
            await getTableData(limit, limit * (event - 1), sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
        } else {
            if (selectedCompanyStatus.toLowerCase() === 'matching complete') {
                await getTableData(limit, limit * (event - 1), sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
            }
            if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                const paginatedUnMatchedData = tableData?.sort((a, b) => {
                }).slice(limit * (event - 1), limit * event);
                const matchedSupplierId = paginatedUnMatchedData.map(sup => sup.matchedSupplierId);
                await getSuppliersByIds(matchedSupplierId);
                const isAllChecked = paginatedUnMatchedData?.filter(item => checkedKeys.includes(item.id));
                setIndeterminate((!isAllChecked?.length || isAllChecked?.length === paginatedUnMatchedData?.length) ? false : true);
                setChecked(isAllChecked?.length === paginatedUnMatchedData?.length ? true : false);
                setPaginatedData(paginatedUnMatchedData);
            }
        }
        setPage(event);
    };

    const onOptionChange = (item, id, type, masterId, rowData) => {
        const tmpKeys = [...checkedKeys];
        let index = tmpKeys.findIndex(checkedRow => checkedRow === id);
        if (type === 'assingToCaller') {
            let tmpCallerAssignedPerVendor = [...callerAssignedPerVendor];
            let vendorIndex = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === id);
            if (vendorIndex === -1) {
                if (item) {
                    tmpCallerAssignedPerVendor.push({ listSupplierId: id, callerAssigned: item, masterId, suppliername: rowData?.suppliername, spend: rowData?.spend, listId: rowData?.listId, matchedSupplierId: rowData?.matchedSupplierId, state: rowData?.state });
                }
            } else {
                if (item) {
                    if (tmpCallerAssignedPerVendor?.[vendorIndex]?.hasOwnProperty('isUpdate')) {
                        tmpCallerAssignedPerVendor[vendorIndex]['isUpdate'] = true;
                        tmpCallerAssignedPerVendor[vendorIndex]['isDelete'] = false;
                    }
                    tmpCallerAssignedPerVendor[vendorIndex]['callerAssigned'] = item;
                } else {
                    if (tmpCallerAssignedPerVendor?.[vendorIndex]?.hasOwnProperty('isDelete')) {
                        tmpCallerAssignedPerVendor[vendorIndex]['isDelete'] = true;
                        tmpCallerAssignedPerVendor[vendorIndex]['isUpdate'] = false;
                        tmpCallerAssignedPerVendor[vendorIndex]['callerAssigned'] = '';
                    } else {
                        tmpCallerAssignedPerVendor.splice(vendorIndex, 1);
                    }
                }
            }
            setCallerAssignedPerVendor(tmpCallerAssignedPerVendor);
        }
        if (type === 'reasonToNotCall') {
            let tmpReasonToNotCallPerVendor = [...reasonToNotCallPerVendor];
            let vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === id);
            if (vendorIndex === -1) {
                if (item) {
                    tmpReasonToNotCallPerVendor.push({ listSupplierId: id, reasonToNotCall: item });
                }
            } else {
                if (item) {
                    if (tmpReasonToNotCallPerVendor?.[vendorIndex]?.hasOwnProperty('isUpdate')) {
                        tmpReasonToNotCallPerVendor[vendorIndex]['isUpdate'] = true;
                        tmpReasonToNotCallPerVendor[vendorIndex]['isDelete'] = false;
                    }
                    tmpReasonToNotCallPerVendor[vendorIndex]['reasonToNotCall'] = item;
                } else {
                    if (tmpReasonToNotCallPerVendor?.[vendorIndex]?.hasOwnProperty('isDelete')) {
                        tmpReasonToNotCallPerVendor[vendorIndex]['isDelete'] = true;
                        tmpReasonToNotCallPerVendor[vendorIndex]['isUpdate'] = false;
                        tmpReasonToNotCallPerVendor[vendorIndex]['reasonToNotCall'] = null;
                    } else {
                        tmpReasonToNotCallPerVendor.splice(vendorIndex, 1);
                    }
                }
            }
            setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor);
        }
        if (type === 'callingScriptId') {
            let tmpCallingScriptPerVendorr = [...callingScriptPerVendor];
            let vendorIndex = tmpCallingScriptPerVendorr.findIndex(vendor => vendor.listSupplierId === id);
            if (vendorIndex === -1) {
                if (item) {
                    tmpCallingScriptPerVendorr.push({ listSupplierId: id, callingScriptId: item });
                }
            } else {
                if (item) {
                    tmpCallingScriptPerVendorr[vendorIndex]['callingScriptId'] = item;
                } else {
                    tmpCallingScriptPerVendorr.splice(vendorIndex, 1);
                }
            }
            setCallingScriptPerVendor(tmpCallingScriptPerVendorr);
        }

        setIsChangesApplied(true);

        if (index !== -1) {
            tmpKeys.splice(index, 1);
            setCheckedKeys(tmpKeys);
            const isAllChecked = tableData.filter(item => tmpKeys.includes(item.id));
            setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true);
            setChecked(isAllChecked?.length === tableData?.length ? true : false);
        }
    };

    const isDisabledOrNot = (type, rowId) => {
        var isDisabled = false;
        if (type === 'reasonToNotCall') {
            const vendorIndex = callerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === rowId && !vendor.isDelete);
            if (vendorIndex !== -1) {
                isDisabled = true;
            }
        }
        if (type === 'assingToCaller') {
            const vendorIndex = reasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === rowId && !vendor.isDelete);
            if (vendorIndex !== -1) {
                isDisabled = true;
            }
        }
        return isDisabled;
    };

    const onSelectAllRemaining = async (checked) => {
        const keysToNotSelect = [];
        setIsLoadingTableData(true);
        let keys = [...checkedKeys];
        if (isReenablementToCalls) {
            if (checked) {
                await dispatch(getAllRemainingReenablementSuppliersIds({ isGetNotInCalls: isShowAllSuppliers ? false : true })).then(async (supplierIds) => {
                    await supplierIds.map(item => keys.push(item));
                    setRemainingCheckedKeys(supplierIds);
                    setIsLoadingTableData(false);
                    const isAllChecked = tableData.filter(item => !keysToNotSelect.includes(item.id));
                    setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true);
                    setChecked(isAllChecked?.length === tableData?.length ? true : false);
                }).catch(() => {
                    setIsLoadingTableData(false);
                });
            } else {
                remainingCheckedKeys.map(item => {
                    let index = keys.findIndex(key => key === item);
                    if (index !== -1) {
                        keys.splice(index, 1);
                    }
                });
                setChecked(false);
                if (keys.length) {
                    setIndeterminate(true);
                } else {
                    setIndeterminate(false);
                }
                setRemainingCheckedKeys([]);
                setIsLoadingTableData(false);
            }
        } else {
            if (selectedCompanyStatus.toLowerCase() === 'matching complete' && currentTab === 'unmatched') {
                if (checked) {
                    await dispatch(getAllRemainingListSuppliersIds({ listId, isGetNotInCalls: isShowAllSuppliers ? false : true })).then(async (listSupplierIds) => {
                        await listSupplierIds.map(item => keys.push(item.id));
                        setRemainingCheckedKeys(listSupplierIds);
                        setIsLoadingTableData(false);
                        const isAllChecked = tableData.filter(item => !keysToNotSelect.includes(item.id));
                        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true);
                        setChecked(isAllChecked?.length === tableData?.length ? true : false);
                    }).catch(() => {
                        setIsLoadingTableData(false);
                    });
                } else {
                    remainingCheckedKeys.map(item => {
                        let index = keys.findIndex(key => key === item.id);
                        if (index !== -1) {
                            keys.splice(index, 1);
                        }
                    });
                    setChecked(false);
                    if (keys.length) {
                        setIndeterminate(true);
                    } else {
                        setIndeterminate(false);
                    }
                    setRemainingCheckedKeys([]);
                    setIsLoadingTableData(false);
                }
            } else {
                if (checked) {
                    var ids = [];
                    var isAllChecked = false;
                    if (currentTab === 'unmatched') {
                        ids = await tableData.map(item => keys.push(item.id));
                        isAllChecked = tableData.filter(item => !keysToNotSelect.includes(item.id));
                        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === tableData?.length) ? false : true);
                        setChecked(isAllChecked?.length === tableData?.length ? true : false);
                        setRemainingCheckedKeys(tableData);
                    } else {
                        ids = await matchedTableData.map(item => keys.push(item.id));
                        isAllChecked = matchedTableData.filter(item => !keysToNotSelect.includes(item.id));
                        setIndeterminate((!isAllChecked?.length || isAllChecked?.length === matchedTableData?.length) ? false : true);
                        setChecked(isAllChecked?.length === matchedTableData?.length ? true : false);
                        setRemainingCheckedKeys(matchedTableData);
                    }
                    setIsLoadingTableData(false);
                } else {
                    remainingCheckedKeys.map(item => {
                        let index = keys.findIndex(key => key === item?.id);
                        if (index !== -1) {
                            keys.splice(index, 1);
                        }
                    });
                    setChecked(false);
                    if (keys.length) {
                        setIndeterminate(true);
                    } else {
                        setIndeterminate(false);
                    }
                    setRemainingCheckedKeys([]);
                    setIsLoadingTableData(false);
                }
            }
        }
        setCheckedKeys(keys);
        setSelectAllRemaining(checked);
    };

    const onConfirmClick = async () => {
        var masterIds = [];
        var deleteMasterIds = [];
        let data = []

        const callersToUpdate = callerAssignedPerVendor?.filter(sup => sup?.isUpdate);
        const callersToDelete = callerAssignedPerVendor?.filter(sup => sup?.isDelete)?.map(({ listSupplierId }) => {
            return listSupplierId;
        });

        const newCallers = callerAssignedPerVendor?.filter(sup => (!sup?.hasOwnProperty('isUpdate') && !sup?.hasOwnProperty('isDelete')));

        if (currentTab === 'unmatched') {
            data = !isReenablementToCalls ? selectedCompanyStatus && selectedCompanyStatus.toLowerCase() === 'match marked complete' ? JSON.parse(JSON.stringify(paginatedData)) : JSON.parse(JSON.stringify(tableData)) : JSON.parse(JSON.stringify(tableData))
        } else {
            data = JSON.parse(JSON.stringify(paginatedMatchedResult))
        }

        for (let index = 0; index < newCallers?.length; index++) {
            const newCaller = newCallers[index];
            let listSupplierId = newCaller?.listSupplierId

            for (let subIndex = 0; subIndex < data?.length; subIndex++) {
                const supplier = data[subIndex];
                if (supplier?.id === listSupplierId) {
                    newCaller['suppliername'] = supplier?.suppliername
                    newCaller['spend'] = supplier?.spend
                    newCaller['listId'] = supplier?.listId
                    newCaller['matchedSupplierId'] = supplier?.matchedSupplierId
                    newCaller['state'] = supplier?.state
                }
            }
        }

        if (currentTab === 'matched') {
            masterIds = newCallers?.filter(sup => sup?.masterId)?.map(({ masterId }) => {
                return masterId;
            });
            deleteMasterIds = callerAssignedPerVendor?.filter(sup => sup?.isDelete && sup?.masterId && !callerAssignedPerVendor.find((caller) => (caller.masterId === sup?.masterId) && !caller?.isDelete))?.map(({ masterId }) => {
                return masterId;
            });
        }

        let isError = false;
        const uniqueMasterIds = masterIds.filter((item, index) => masterIds.indexOf(item) === index);
        const uniqueDeleteMasterIds = deleteMasterIds.filter((item, index) => deleteMasterIds.indexOf(item) === index);

        if (!reasonToNotCallPerVendor.length && !callerAssignedPerVendor.length && !callingScriptPerVendor.length) {
            toast.show({
                title: 'Warning',
                description: 'Please select Reason to not call or Caller Assigned!'
            });
            return;
        }
        if (reasonToNotCallPerVendor.length) {
            setIsSendToCallLoading(true);
            await dispatch(listSuppliersAddReasonToNotCall({ listSuppliers: reasonToNotCallPerVendor })).then(() => {
                setIsSendToCallLoading(false);
            }).catch(() => {
                setIsSendToCallLoading(false);
                isError = true;
                return;
            });
        }

        if (newCallers?.length) {
            setIsSendToCallLoading(true);
            await dispatch(sendListSuppliersToCalls({
                suppliersData: newCallers,
                isPausedSequencing: parseInt(selectedCompanyDetails?.pausedSupCount) === 0 ? false : true,
                isReenablement: isReenablementToCalls
            })).then(() => {
                setIsSendToCallLoading(false);
            }).catch(() => {
                isError = true;
                setIsSendToCallLoading(false);
                return;
            });
        }

        if (callingScriptPerVendor?.length) {
            setIsSendToCallLoading(true);
            await dispatch(changeListSuppliersCallingScript({ listSuppliers: callingScriptPerVendor })).then(() => {
                setIsSendToCallLoading(false);
            }).catch(() => {
                isError = true;
                setIsSendToCallLoading(false);
                return;
            });
        }

        if (callersToUpdate?.length) {
            setIsSendToCallLoading(true);
            await dispatch(updateListSuppliersInCalls(isReenablementToCalls ? { supplierData: callersToUpdate } : { listSuppliers: callersToUpdate })).then(() => {
                setIsSendToCallLoading(false);
            }).catch(() => {
                isError = true;
                setIsSendToCallLoading(false);
                return;
            });
        }

        if (callersToDelete?.length) {
            setIsSendToCallLoading(true);
            await dispatch(deleteListSuppliersInCalls(isReenablementToCalls ? { supplierIds: callersToDelete } : { listSupplierIds: callersToDelete })).then(() => {
                setIsSendToCallLoading(false);
            }).catch(() => {
                isError = true;
                setIsSendToCallLoading(false);
                return;
            });
        }

        if (!isReenablementToCalls) {
            if (uniqueMasterIds?.length) {
                setIsSendToCallLoading(true);
                await dispatch(updateMasterSupplierQAStatus(uniqueMasterIds, 9)).then(() => {
                    setIsSendToCallLoading(false);
                }).catch(() => {
                    isError = true;
                    setIsSendToCallLoading(false);
                    return;
                });
            }
            if (uniqueDeleteMasterIds?.length) {
                setIsSendToCallLoading(true);
                await dispatch(updateMasterSupplierQAStatus(uniqueDeleteMasterIds, 6)).then(() => {
                    setIsSendToCallLoading(false);
                }).catch(() => {
                    isError = true;
                    setIsSendToCallLoading(false);
                    return;
                });
            }
        }

        if (!isError) {
            setReasonToNotCallPerVendor([]);
            setCallerAssignedPerVendor([]);
            setCallingScriptPerVendor([]);
            if (currentTab === 'matched') {
                getMatchedTableData(isShowAllSuppliers, inCallsFilters, sortType, sortColumn);
                setMatchedPage(1);
            } else {
                getTableData(limit, 0, sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
                setPage(1);
            }
        }
    };

    const onApplyClick = async () => {
        if (checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No list supplier selected!'
            })
            return
        }
        const tmpReasonToNotCallPerVendor = [...reasonToNotCallPerVendor]
        const tmpCallerAssignedPerVendor = [...callerAssignedPerVendor]
        const tmpCallingScriptPerVendor = [...callingScriptPerVendor]
        for (let key in checkedKeys) {
            const vendorIndex = tmpReasonToNotCallPerVendor.findIndex(vendor => vendor.listSupplierId === checkedKeys[key])
            if (vendorIndex === -1) {
                if (reasonToNotCall) {
                    tmpReasonToNotCallPerVendor.push({ listSupplierId: checkedKeys[key], reasonToNotCall: reasonToNotCall })
                }
            } else {
                if (reasonToNotCall) {
                    tmpReasonToNotCallPerVendor[vendorIndex]['reasonToNotCall'] = reasonToNotCall
                } else {
                    tmpReasonToNotCallPerVendor.splice(vendorIndex, 1);
                }
            }
            const vendorIndex1 = tmpCallerAssignedPerVendor.findIndex(vendor => vendor.listSupplierId === checkedKeys[key])

            if (vendorIndex1 === -1) {
                if (callerAssigned) {
                    tmpCallerAssignedPerVendor.push({ listSupplierId: checkedKeys[key], callerAssigned: callerAssigned })
                }
            } else {
                if (callerAssigned) {
                    if (tmpCallerAssignedPerVendor?.[vendorIndex1]?.hasOwnProperty('isUpdate')) {
                        tmpCallerAssignedPerVendor[vendorIndex1]['isUpdate'] = true
                        tmpCallerAssignedPerVendor[vendorIndex1]['isDelete'] = false
                    }
                    tmpCallerAssignedPerVendor[vendorIndex1]['callerAssigned'] = callerAssigned
                } else {
                    if (tmpCallerAssignedPerVendor?.[vendorIndex1]?.hasOwnProperty('isDelete')) {
                        tmpCallerAssignedPerVendor[vendorIndex1]['isDelete'] = true
                        tmpCallerAssignedPerVendor[vendorIndex1]['isUpdate'] = false
                        tmpCallerAssignedPerVendor[vendorIndex1]['callerAssigned'] = ''
                    } else {
                        tmpCallerAssignedPerVendor.splice(vendorIndex1, 1);
                    }
                }
            }
            const vendorIndex2 = tmpCallingScriptPerVendor.findIndex(vendor => vendor.listSupplierId === checkedKeys[key])
            if (vendorIndex2 === -1) {
                if (callingScriptId) {
                    tmpCallingScriptPerVendor.push({ listSupplierId: checkedKeys[key], callingScriptId: callingScriptId })
                }
            } else {
                if (callingScriptId) {
                    tmpCallingScriptPerVendor[vendorIndex2]['callingScriptId'] = callingScriptId
                } else {
                    tmpCallingScriptPerVendor.splice(vendorIndex2, 1);
                }
            }
        }
        setReasonToNotCallPerVendor(tmpReasonToNotCallPerVendor)
        setCallerAssignedPerVendor(tmpCallerAssignedPerVendor)
        setCallingScriptPerVendor(tmpCallingScriptPerVendor)
        setReasonToNotCall('')
        setCallerAssigned('')
        setCallingScriptId(null)
        setIsChangesApplied(true)
        setCheckedKeys([])
        setIndeterminate(false)
        setChecked(false)
        setSelectAllRemaining(false)
        setRemainingCheckedKeys([])
    }

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, disabled, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
                disabled={disabled}
            />
        </Cell>
    );

    const SelectCell = ({ rowData, onChange, checkedKeys, dataKey, disabled, placeholder, options, columnValue, type, isDisabled, ...props }) => {
        let callingScriptValue = null;
        if (type === 'callingScriptId') {
            callingScriptValue = columnValue?.length && columnValue.find(vendor => vendor.listSupplierId === rowData.id);
            if (callingScriptValue) {
                callingScriptValue = callingScriptValue?.[type];
            } else {
                callingScriptValue = options.find(option => option?.id === rowData?.callingScriptId)?.id;
            }
        }

        const masterSup = matchedSupplierList?.find(sup => sup?.id === rowData?.matchedSupplierId);

        const matchedSupplierId = masterSup?.isMaster ? rowData?.matchedSupplierId : masterSup?.masterId;

        return <Cell {...props} style={{ padding: 0 }} className='selector-cell fw-normal'>
            <SelectPicker
                placeholder={placeholder}
                menuClassName='text-black h4 mb-0'
                data={options.map(
                    item => ({
                        label: type === 'callerAssigned' ? item?.label : type === 'callingScriptId' ? item?.title : item,
                        value: type === 'callerAssigned' ? item?.value : type === 'callingScriptId' ? item?.id : item
                    })
                )}
                value={type === 'callingScriptId' ? callingScriptValue : (columnValue?.length && columnValue.find(vendor => vendor.listSupplierId === rowData.id)) ? columnValue.find(vendor => vendor.listSupplierId === rowData.id)?.[type] : null}
                style={{ color: '#000', width: '180px' }}
                onChange={(item) => { onChange(item, rowData.id, type === 'callerAssigned' ? 'assingToCaller' : type, matchedSupplierId, rowData); }}
                disabled={isDisabled && isDisabled(type === 'callerAssigned' ? 'assingToCaller' : type, rowData['id'])}
                maxHeight={200}
            />
        </Cell>;
    };

    const matchedTabColumns = [
        { name: 'suppliername', label: 'Supplier Name' },
        { name: 'state', label: 'State' },
        { name: 'spend', label: 'Spend' },
        { name: 'lastPaymentDate', label: 'Last Payment Date' },
        { name: 'globalAcceptance', label: 'Global Acceptance' },
        { name: 'cardAcceptance', label: 'Card Acceptance' },
        { name: 'cardRemittance', label: 'Card Remittance' }
    ]

    const headerElements = (columns) => columns.map((col, index) => {
        return (
            <Column
                fullText={true}
                resizable
                sortable={(index === 0 || index === 2) ? true : false}
                key={col.name}
                width={index === 0 ? 250 : 120}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell dataKey={col.name}>
                    {rowData => {
                        if (col.name === 'spend') {
                            var spend = rowData?.[col.name] ? Math.round(rowData?.[col.name]) : ''
                            spend = spend ? '$ ' + spend : "";
                            return <p title={spend ? spend : ''} className="mb-0 text-black">{spend ? spend : ''}</p>;
                        }
                        if (col.name === 'paymentCount') {
                            const paymentCount = rowData?.[col.name] ?? rowData?.supplierDetail?.[col.name];
                            return <p title={paymentCount ?? ''} className="mb-0 text-black">{paymentCount ?? ''}</p>;
                        }
                        return <p title={rowData?.[col.name] ? rowData?.[col.name] : ''} className="mb-0 text-black">{rowData?.[col.name] ? rowData?.[col.name] : ''}</p>;
                    }}
                </Cell>
            </Column>
        );
    });

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
    };

    const handleAddFilterClick = () => {
        let filters = inCallsFilters;
        setShowFilters(!showFilters);
        if (!isFilterApplied) {
            setInCallsFilters({});
        }
        if (Object.keys(filters).length === 0 && isFilterApplied) {
            setIsFilterApplied(false);
        }
    };

    const handleFiltersChange = (value, optionName) => {
        if (optionName === 'spendComparisionChange') {
            setIsSpendGreater(value)
            return
        }
        if (optionName === 'showAllAssigned') {
            setIsShowAllSuppliers(value);
            setInCallsFilters({
                ...inCallsFilters,
                [optionName]: value
            });
        } else {
            if (!value) {
                let filterValues = { ...inCallsFilters };
                delete filterValues?.[optionName];
                setInCallsFilters(filterValues);
            } else {
                setInCallsFilters({
                    ...inCallsFilters,
                    [optionName]: value
                });
            }
        }
    };

    const handleCancelClick = () => {
        if (Object.keys(inCallsFilters).length > 0) {
            setInCallsFilters({});
        } else {
            setShowFilters(false);
        }
    };

    const handleApplyFilterClick = () => {
        setShowFilters(!showFilters);
        let filters = inCallsFilters;
        setIsFilterApplied(true);
        if (currentTab === 'matched') {
            getMatchedTableData(isShowAllSuppliers, inCallsFilters, sortType, sortColumn);
        } else {
            getTableData(limit, limit * (page - 1), sortColumn, sortType, false, isShowAllSuppliers, filters);
        }
    };

    const handleResetFilterClick = () => {
        let filters = inCallsFilters;
        if (Object.keys(filters).length > 0 || isFilterApplied) {
            setInCallsFilters({});
            setIsFilterApplied(false);
            if (currentTab === 'matched') {
                getMatchedTableData(false, {}, sortType, sortColumn);
            } else {
                getTableData(limit, limit * (page - 1), sortColumn, sortType, false, false, {});
            }
            setIsSpendGreater(true)
        }
    };

    const handleClickTab = (tab) => {
        setCurrentTab(tab);
        setRemainingCheckedKeys([]);
        setIndeterminate(false);
        setChecked(false);
        setCheckedKeys([]);
        setMatchedPage(1);
        setPage(1);
    };

    const handleChangeMatchedLimit = async (dataKey) => {
        setMatchedPage(1);
        setMatchedLimit(dataKey);
        let sortedData = onSortColumn(matchedTableData, sortType, sortColumn);
        const paginatedMatchedData = sortedData.slice(dataKey * (1 - 1), dataKey * 1);

        const matchedSupplierIdList = paginatedMatchedData?.map(item => item?.matchedSupplierId);
        await getSuppliersByIds(matchedSupplierIdList);
        setCheckedKeys([]);
        setIndeterminate(false);
        setChecked(false);
        setPaginatedMatchedResult(paginatedMatchedData);
    };

    const handleChangeMatchedPage = async (event) => {
        let suppliersCardData = []
        let matchedSuppliersData = []
        let paginatedMatchedData = matchedTableData?.sort((a, b) => {
        }).slice(matchedLimit * (event - 1), matchedLimit * event);
        const matchedSupplierIdList = paginatedMatchedData?.map(item => item?.matchedSupplierId);

        if (matchedSupplierIdList && matchedSupplierIdList?.length > 0) {
            matchedSuppliersData = await getSuppliersByIds(matchedSupplierIdList)
        }

        setMatchedPage(event);
        if (paginatedMatchedData?.length > 0) {
            let masterIds = []
            let historicPaymentsMaxDates = []
            if (selectedCompanyStatus.toLowerCase() === 'match marked complete') {
                masterIds = paginatedMatchedData?.map((row) => row?.masterCardAcceptance?.supplierId)
            } else {
                masterIds = paginatedMatchedData?.map((row) => row?.matchedMasterId)

                const matchedSuppliersIds = paginatedMatchedData?.map(({ matchedSupplierId }) => {
                    let supplier = matchedSuppliersData?.find((sup) => sup?.id === matchedSupplierId);
                    matchedSupplierId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
                    return matchedSupplierId;
                });

                const uniqueMatchedSuppliersIds = [...new Set(matchedSuppliersIds)];
                if (uniqueMatchedSuppliersIds && uniqueMatchedSuppliersIds?.length > 0) {
                    suppliersCardData = await dispatch(getSuppliersWithCardAcceptanceData(uniqueMatchedSuppliersIds)).then(res => res).catch(() => []);
                }
            }

            if (masterIds && masterIds?.length > 0) {
                historicPaymentsMaxDates = await dispatch(getMaxLastHistoricalPayment({ masterIds }))
                    .then(res => res)
                    .catch(() => []);
            }

            paginatedMatchedData = await Promise.all(paginatedMatchedData?.map(async (row) => {
                // get global acceptance
                let cardData = null
                let masterId = null
                if (selectedCompanyStatus?.toLowerCase() === 'match marked complete') {
                    cardData = row?.masterCardAcceptance
                    masterId = row?.masterCardAcceptance?.supplierId
                } else {
                    cardData = { isAcceptGlobalAcceptance: row?.isAcceptMatchedGlobalAcceptance }
                    masterId = row?.matchedMasterId

                    let supplier = matchedSuppliersData?.find((sup) => sup?.id === row?.matchedSupplierId);

                    const matchedMasterId = supplier?.isMaster ? supplier?.id : supplier?.masterId;
                    const listMasterSupCardAcc = suppliersCardData?.filter((cardData) => cardData?.cardAcceptance?.[0]?.supplierId === matchedMasterId)?.[0] || null;

                    if (listMasterSupCardAcc) {
                        // get card remittance
                        var acceptsEmail, acceptsPhone, acceptsWeb, acceptsFax, acceptsEcom, acceptsInApp, acceptsPos
                        acceptsEmail = acceptsPhone = acceptsWeb = acceptsFax = acceptsEcom = acceptsInApp = acceptsPos = false
                        if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByEmail && listMasterSupCardAcc?.cardAcceptanceEmails?.length > 0) {
                            acceptsEmail = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByPhone && (
                            (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPOTSPhone && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentByPhoneValue) ||
                            (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptIVRPhone && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentIVRPhone)
                        )) {
                            acceptsPhone = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && (
                            (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.portalUrl) ||
                            (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAccept3rdPartyPortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.thirdPartyPortalUrl)
                        )) {
                            acceptsWeb = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByFax && listMasterSupCardAcc?.cardAcceptance?.[0]?.cardPaymentByFaxValue) {
                            acceptsFax = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptEcommercePortal) {
                            acceptsEcom = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptCardPaymentByOnlinePortal && listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptInAppPortal) {
                            acceptsInApp = true
                        } else if (listMasterSupCardAcc?.cardAcceptance?.[0]?.isAcceptPointOfSalePortal) {
                            acceptsPos = true
                        }

                        if (acceptsEmail || acceptsPhone || acceptsWeb || acceptsFax || acceptsEcom || acceptsInApp || acceptsPos) {
                            row.cardRemittance = "Yes"
                        } else {
                            row.cardRemittance = "No"
                        }
                    } else {
                        row.cardRemittance = "No"
                    }
                }
                const acceptanceType = await getGlobalAcceptanceValue(cardData, masterId, dispatch)
                row.globalAcceptance = acceptanceType || 'Unknown'

                // Maximum last payment date
                const maxLastPaymentDate = historicPaymentsMaxDates?.find(payment => parseInt(payment.masterId) === parseInt(masterId))?.maxLastPayment
                row.lastPaymentDate = maxLastPaymentDate ? moment(maxLastPaymentDate).format('MM/DD/YYYY') : ''
                return row
            }))
        }
        setPaginatedMatchedResult(paginatedMatchedData);
        setIndeterminate(false);
        setChecked(false);
    };

    const getSuppliersByIds = async (matchedSupplierIdList) => {
        if (matchedSupplierIdList?.length === 0) {
            setMatchedSupplierList([]);
            return [];
        }
        setIsLoadingTableData(true);
        const data = await dispatch(getSuppliersDataByIds(matchedSupplierIdList)).then((res) => {
            setMatchedSupplierList(res);
            setIsLoadingTableData(false);
            return res
        }).catch(err => {
            setIsLoadingTableData(false);
            toast.show({
                title: 'Warning',
                description: err.message
            });
            return []
        });
        return data
    };

    const onMarkCompleteClick = async () => {
        setIsMarkingListComplete(true);
        const listSuppliers = await dispatch(getListSuppliers({
            listId: listId,
            type: 'full',
            limit: null,
            offset: null,
            sortColumn: "suppliername",
            sortType: "asc",
            isMarkListComplete: true,
            isGetAllColumns: true
        })).then(res => {
            return res?.listSuppliers;
        }).catch(() => {
            toast.show({
                title: 'Warning',
                description: 'Failed to get list Suppliers!',
            });
            return [];
        });

        if (!listSuppliers || listSuppliers?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No List Suppliers found to mark as complete!',
            });
            setIsMarkingListComplete(false);
            return;
        }

        const tmpData = await listSuppliers.map(row => {
            const tmpSupplierData = {};
            supplierAllColumns.forEach(column => {
                if (column.name === 'autoCreateMaster') {
                    return;
                }
                if (column.name === 'state') {
                    tmpSupplierData[column.name] = row[column.name];
                    let stateCode = getAbbreviatedState(row?.abbreviatedState, row?.state);
                    tmpSupplierData['abbreviatedState'] = stateCode;
                } else {
                    tmpSupplierData[column.name] = row[column.name];
                }
            });
            tmpSupplierData['matchedSupplierId'] = row?.matchedSupplierId;
            tmpSupplierData['listSupplierId'] = row?.id;
            tmpSupplierData['isInCalls'] = row?.isInCalls;
            return tmpSupplierData;
        });

        dispatch(markListComplete(listId, tmpData)).then(() => {
            setIsMarkingListComplete(false);
            handleClose(true);
        }).catch(() => {
            setIsMarkingListComplete(false);
        });
    };

    const handleModalClose = async () => {
        if (isFromMarkListComplete) {
            onMarkCompleteClick();
        } else {
            handleClose();
        }
    };

    const onUnassign = async () => {
        dispatch(unassigningSuppliers({ listSupplierIds: checkedKeys })).then((res) => {
            toast.show({
                title: 'Success',
                description: 'Successfully Unassigned',
            });
            setChecked([]);
            if (currentTab === 'matched') {
                getMatchedTableData(isShowAllSuppliers, inCallsFilters, sortType, sortColumn);
                setMatchedPage(1);
            } else {
                getTableData(limit, 0, sortColumn, sortType, false, isShowAllSuppliers, inCallsFilters);
                setPage(1);
            }
        }).catch((err) => {
            toast.show({
                title: 'Danger',
                description: 'Unable to Unassign',
            });
        });
    };

    useEffect(() => {
        if (listId) {
            if (partnerId) {
                dispatch(getCallingScriptsByPartnerId(partnerId)).then(scripts => {
                    setCallingScripts(scripts);
                }).catch(() => {
                    setCallingScripts([]);
                });
            }

            if (currentTab === 'matched') {
                getMatchedTableData(isShowAllSuppliers, inCallsFilters, sortType, sortColumn);
                setTableData([]);
                setMatchedPage(1);
            } else {
                getTableData(limit, 0, sortColumn, sortType, true, isShowAllSuppliers, inCallsFilters);
                setMatchedTableData([]);
                setPage(1);
            }
        }
    }, [currentTab]);

    useEffect(() => {
        if (currentTab === 'matched') {
            let sortedData = onSortColumn(matchedTableData, sortType, sortColumn);
            const paginatedMatchedData = sortedData.slice(matchedLimit * (1 - 1), matchedLimit * 1);
            setPaginatedMatchedResult(paginatedMatchedData);
            setMatchedPage(1);
            const isAllChecked = matchedTableData?.filter(item => checkedKeys.includes(item.id));
            setIndeterminate((!isAllChecked?.length || isAllChecked?.length === matchedTableData?.length) ? false : true);
            setChecked(isAllChecked?.length === matchedTableData?.length ? true : false);
            setDropDownActionsValue(isShowAllSuppliers, inCallsFilters, matchedTableData).then(res => res).catch(err => []);
            setIsLoadingTableData(false);
        } else {
            getTableData(limit, 0, sortColumn, sortType, true, isShowAllSuppliers, inCallsFilters);
            setMatchedTableData([]);
            setPage(1);
        }
    }, [sortColumn, sortType]);

    const isSelectAllDisabled = currentTab === 'unmatched' ? ((reasonToNotCallPerVendor.length + callerAssignedPerVendor.length) === totalTableRecords) : ((reasonToNotCallPerVendor.length + callerAssignedPerVendor.length) === totalMatchedTableRecords);

    return (
        <Modal
            backdrop='static'
            className="send-to-call-modal w-75"
            show={show}
            size="xl"
            onClick={() => { !isMarkingListComplete && handleModalClose(); }}
            onHide={() => { !isMarkingListComplete && handleModalClose(); }}
        >
            <Modal.Header>
            </Modal.Header>
            <Modal.Body>
                <div className='call-vendor-list'>
                    <div className='d-flex align-items-center gap-5 mb-4'>
                        <h2 className='mb-0 fw-bold text-black'>{selectedCompany}</h2>
                        <div className='ms-auto'>
                            <CheckboxComponent
                                label='Select All Remaining'
                                onChange={(checked) => { onSelectAllRemaining(checked); }}
                                checked={selectAllRemaining}
                                disabled={isSelectAllDisabled || isLoadingTableData}
                            />
                        </div>
                        <div className='ms-auto position-relative flex-grow-1'>
                            {!showFilters && (
                                <button className={`ms-4 p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end${!isFilterApplied ? ' bg-gray' : ' bg-green'}`} onClick={handleResetFilterClick} disabled={!isFilterApplied}> Reset Filter </button>
                            )}
                            <button className='bg-gray p-3 ps-4 pe-4 text-white h5 mb-0 rounded float-end' onClick={handleAddFilterClick}> + Add Filter </button>
                            {isFromMarkListComplete && (
                                <button className='rounded h5 mb-0 text-white bg-dark-blue pt-3 pb-3 p-4 me-4 float-end' onClick={() => { onMarkCompleteClick(); }} disabled={isMarkingListComplete || isLoadingTableData}>Mark List Complete</button>
                            )}
                            {showFilters && (
                                <div className='position-absolute top-100 end-0 filter-component-parent p-2 bg-white rounded shadow'>
                                    <FilterComponent
                                        columns={filterColumns}
                                        filterValues={inCallsFilters}
                                        onChangeFilters={(value, optionName) => { handleFiltersChange(value, optionName); }}
                                        onCancel={() => { handleCancelClick(); }}
                                        onApplyFilter={() => { handleApplyFilterClick(); }}
                                        listId={listId}
                                        vendrosInCalls={isReenablementToCalls ? tableData : currentTab === 'matched' ? matchedTableData : (selectedCompanyStatus.toLowerCase() === 'match marked complete' && currentTab === 'unmatched') ? tableData : null}
                                        isSpendGreaterValue={isSpendGreater}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='header d-flex mb-3 align-items-center gap-2'>
                        <h3 className='mb-0 fw-bold text-black'>Send to Calls</h3>
                        <div className='d-flex gap-3 align-items-center select-options-parent flex-grow-1 justify-content-end'>
                            {!isReenablementToCalls && (
                                <div className='w-25 d-flex'>
                                    <SelectPicker
                                        className='flex-grow-1'
                                        placeholder="Reason to not call"
                                        menuClassName='text-black h4 mb-0'
                                        data={reasonToNotCallOptions.map(option => ({
                                            label: option,
                                            value: option
                                        }))}
                                        value={reasonToNotCall ? reasonToNotCall : null}
                                        style={{ color: '#000' }}
                                        onChange={(item) => { setReasonToNotCall(item || null); setIsChangesApplied(false); }}
                                        disabled={callerAssigned ? true : false}
                                    />
                                </div>
                            )}
                            <div className='w-25 d-flex'>
                                <SelectPicker
                                    className='flex-grow-1'
                                    placeholder="Assign to caller"
                                    menuClassName='text-black h4 mb-0'
                                    data={callerOptions.map(option => ({
                                        label: option?.label,
                                        value: option?.value
                                    }))}
                                    value={callerAssigned ? callerAssigned : null}
                                    style={{ color: '#000' }}
                                    onChange={(item) => { setCallerAssigned(item || null); setIsChangesApplied(false); }}
                                    disabled={reasonToNotCall ? true : false}
                                />
                            </div>
                            {!isReenablementToCalls && (<div className='w-25 d-flex'>
                                <SelectPicker
                                    className='flex-grow-1'
                                    placeholder="Calling script"
                                    menuClassName='text-black h4 mb-0'
                                    data={callingScripts.map(option => ({
                                        label: option?.title,
                                        value: option?.id
                                    }))}
                                    value={callingScriptId ? callingScriptId : null}
                                    style={{ color: '#000' }}
                                    onChange={(item) => { setCallingScriptId(item || null); setIsChangesApplied(false); }}
                                />
                            </div>
                            )}
                            {isAdmin && <button className='rounded h4 mb-0 text-white bg-green pt-3 pb-3 p-4' onClick={() => { onUnassign(); }} disabled={checkedKeys?.length === 0 ? true : false} >Unassign</button>}

                            <button className='rounded h4 mb-0 text-white bg-green pt-3 pb-3 p-4' onClick={() => { onApplyClick(); }} disabled={isChangesApplied === null || isChangesApplied}>Apply</button>
                        </div>
                    </div>
                    {!isReenablementToCalls && (
                        <div className="page-tabs gap-4 gap-md-5 mb-3">
                            {
                                tabs.map(tab => {
                                    return <button
                                        key={tab.value}
                                        type="button"
                                        className={`page-tab me-0${currentTab === tab.value ? ' selected' : ''}`}
                                        onClick={() => { handleClickTab(tab.value); }}
                                    >
                                        {tab.label}
                                    </button>;
                                })
                            }
                        </div>
                    )}
                    <div className={`border border-2 position-relative${(isLoadingTableData || isSendToCallLoading || isMarkingListComplete) ? ' loading' : ''}`}>
                        {(isLoadingTableData || isSendToCallLoading || isMarkingListComplete) && <LoaderComponent />}
                        {currentTab === 'unmatched' && (
                            <>
                                <Table
                                    virtualized={true}
                                    data={!isReenablementToCalls
                                        ? selectedCompanyStatus &&
                                            selectedCompanyStatus.toLowerCase() === 'match marked complete'
                                            ? paginatedData
                                            : tableData
                                        : tableData}
                                    height={540}
                                    minHeight={100}
                                    rowHeight={50}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                >
                                    <Column width={50} align="center">
                                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Checkbox
                                                checked={checked}
                                                indeterminate={indeterminate}
                                                onChange={handleCheckAll}
                                            />
                                        </HeaderCell>
                                        <CheckCell
                                            dataKey="id"
                                            checkedKeys={checkedKeys}
                                            onChange={handleCheck}
                                        />
                                    </Column>
                                    {headerElements(columns)}
                                    {!isReenablementToCalls && (
                                        <Column width={180}>
                                            <HeaderCell className='fw-bold text-black'>Reason to not call</HeaderCell>
                                            <SelectCell
                                                onChange={onOptionChange}
                                                options={reasonToNotCallOptions}
                                                placeholder="Reason to not call"
                                                columnValue={reasonToNotCallPerVendor}
                                                isDisabled={isDisabledOrNot}
                                                type='reasonToNotCall'
                                                menuMaxHeight={200}
                                            />
                                        </Column>
                                    )}
                                    <Column width={180}>
                                        <HeaderCell className='fw-bold text-black'>Assign to caller</HeaderCell>
                                        <SelectCell
                                            onChange={onOptionChange}
                                            options={callerOptions}
                                            placeholder="Assign to caller"
                                            columnValue={callerAssignedPerVendor}
                                            isDisabled={isDisabledOrNot}
                                            type='callerAssigned'
                                            menuMaxHeight={200}
                                        />
                                    </Column>
                                    {!isReenablementToCalls && (<Column width={180}>
                                        <HeaderCell className='fw-bold text-black'>Calling script</HeaderCell>
                                        <SelectCell
                                            onChange={onOptionChange}
                                            options={callingScripts}
                                            placeholder="Calling script"
                                            columnValue={callingScriptPerVendor}
                                            type='callingScriptId'
                                            menuMaxHeight={200}
                                        />
                                    </Column>
                                    )}
                                </Table>
                                <div className="full-vendor-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={true}
                                        last={true}
                                        maxButtons={5}
                                        activePage={page}
                                        showInfo
                                        displayLength={limit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={totalTableRecords}
                                        onChangeLength={(limit) => { handleChangeLimit(limit); }}
                                        onChangePage={(page) => { handleChangePage(page); }}
                                    />
                                </div>
                            </>
                        )}
                        {currentTab === 'matched' && (
                            <>
                                <Table
                                    virtualized={true}
                                    affixHeader={true}
                                    data={paginatedMatchedResult}
                                    height={540}
                                    minHeight={100}
                                    rowHeight={50}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}
                                >
                                    <Column width={50} align="center">
                                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Checkbox
                                                checked={checked}
                                                indeterminate={indeterminate}
                                                onChange={handleCheckAll}
                                            />
                                        </HeaderCell>
                                        <CheckCell
                                            dataKey="id"
                                            checkedKeys={checkedKeys}
                                            onChange={handleCheck}
                                        />
                                    </Column>
                                    {headerElements(matchedTabColumns)}
                                    <Column width={180}>
                                        <HeaderCell className='fw-bold text-black'>Reason to not call</HeaderCell>
                                        <SelectCell
                                            onChange={onOptionChange}
                                            options={reasonToNotCallOptions}
                                            placeholder="Reason to not call"
                                            columnValue={reasonToNotCallPerVendor}
                                            isDisabled={isDisabledOrNot}
                                            type='reasonToNotCall'
                                            menuMaxHeight={200}
                                        />
                                    </Column>
                                    <Column width={180}>
                                        <HeaderCell className='fw-bold text-black'>Assign to caller</HeaderCell>
                                        <SelectCell
                                            onChange={onOptionChange}
                                            options={callerOptions}
                                            placeholder="Assign to caller"
                                            columnValue={callerAssignedPerVendor}
                                            isDisabled={isDisabledOrNot}
                                            type='callerAssigned'
                                            menuMaxHeight={200}
                                        />
                                    </Column>
                                    <Column width={180}>
                                        <HeaderCell className='fw-bold text-black'>Calling script</HeaderCell>
                                        <SelectCell
                                            onChange={onOptionChange}
                                            options={callingScripts}
                                            placeholder="Calling script"
                                            columnValue={callingScriptPerVendor}
                                            type='callingScriptId'
                                            menuMaxHeight={200}
                                        />
                                    </Column>
                                </Table>
                                <div className="full-vendor-table-pagination">
                                    <Pagination
                                        prev
                                        next
                                        first={true}
                                        last={true}
                                        maxButtons={5}
                                        activePage={matchedPage}
                                        showInfo
                                        displayLength={matchedLimit}
                                        lengthMenu={[
                                            {
                                                label: '10',
                                                value: 10,
                                            },
                                            {
                                                label: '20',
                                                value: 20,
                                            },
                                            {
                                                label: '30',
                                                value: 30,
                                            },
                                            {
                                                label: '50',
                                                value: 50,
                                            },
                                            {
                                                label: '100',
                                                value: 100,
                                            },
                                        ]}
                                        total={totalMatchedTableRecords}
                                        onChangeLength={(limit) => { handleChangeMatchedLimit(limit); }}
                                        onChangePage={(page) => { handleChangeMatchedPage(page); }}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className='mt-3'>
                <button className='rounded h4 mb-0 text-white bg-green pt-3 pb-3 p-4' onClick={() => { onConfirmClick(); }} disabled={(!isChangesApplied || (!reasonToNotCallPerVendor.length && !callerAssignedPerVendor.length && !callingScriptPerVendor)) ? true : false}>Confirm</button>
            </Modal.Footer>
        </Modal>
    );
};

export default SendToCallsModal;